export const namespaced = true;

import BrandService from '@/services/BrandService.js';
import cloneDeep from 'lodash/cloneDeep';
import map from 'lodash/map';
import omit from 'lodash/omit';
import pick from 'lodash/pick';
import { basicPresent, basicSubFieldPresent } from '@/presenters/fields';

export const state = {
  brands: [],
  brand: {},
  editingBrand: null,
};

export const mutations = {
  SET_BRANDS(state, brands) {
    state.brands = brands;
  },
  CLEAR_BRANDS(state) {
    state.brands = [];
  },
  SET_BRAND(state, brand) {
    state.brand = brand;
  },
  SET_EDITING_BRAND(state, brand) {
    state.editingBrand = brand;
  },
  DELETE_EDITING_BRAND(state) {
    state.editingBrand = null;
  },
  UPDATE_BRAND(state, brand) {
    state.brand = brand;
  },
  ADD_BRAND(state, brand) {
    state.brand = brand;
  },
  CHANGE_BRAND_PASSWORD() {
    // We don't store Password inside Vuex, so we don't need to do anything here
  },
  FREEZE_BRAND() {
    // We only freeze Brand, so we don't need to do anything here
  },
};

export const actions = {
  setCurrentBrandUser({ commit }, brand) {
    commit('SET_BRAND', brand);
  },
  fetchBrands({ commit }, { data }) {
    return BrandService.all(data).then((response) => {
      commit('SET_BRANDS', response.data);
    });
  },
  clearBrands({ commit }) {
    commit('CLEAR_BRANDS');
  },
  fetchBrand({ commit }, id) {
    return BrandService.get(id).then((response) => {
      commit('SET_BRAND', response.data);
      return response.data;
    });
  },
  startEditingBrand({ commit }, brand) {
    commit('SET_EDITING_BRAND', brand);
  },
  finishEditingBrand({ commit, state }, id) {
    if (state.editingBrand) {
      let formattedBrand = cloneDeep(state.editingBrand);
      if (formattedBrand.corporation) {
        formattedBrand.corporationId = formattedBrand.corporation.id;
        formattedBrand = omit(formattedBrand, ['corporation']);
      }
      if (id) {
        return BrandService.update(id, formattedBrand).then((response) => {
          commit('DELETE_EDITING_BRAND');
          commit('UPDATE_BRAND', response.data);
        });
      } else {
        return BrandService.create(formattedBrand).then((response) => {
          commit('DELETE_EDITING_BRAND');
          commit('ADD_BRAND', response.data);
        });
      }
    }
  },
  clearEditingBrand({ commit, state }) {
    if (state.editingBrand) {
      commit('DELETE_EDITING_BRAND');
    }
  },
  changeBrandPassword({ commit }, { id, password }) {
    return BrandService.changePassword(id, password).then(() => {
      commit('CHANGE_BRAND_PASSWORD');
    });
  },
  freezeBrand({ commit }, payload) {
    let formattedFrozenData = {};
    if (payload.frozenMonth != 'now') {
      formattedFrozenData['frozenDatetime'] = payload.frozenMonth;
    }
    return BrandService.frozen(payload.id, formattedFrozenData).then(() => {
      commit('FREEZE_BRAND');
    });
  },
};

export const getters = {
  getBrandById: (state) => (id) => {
    return state.brands.find((item) => item.id == id);
  },
  totalBrands: (state) => {
    return state.brands.length;
  },
  getExcelFormattedBrands: (state) => (fields) => {
    return map(state.brands, (brand) => {
      let data = {
        法人名: basicSubFieldPresent(brand, 'corporation', 'name'),
        ブランドID: basicPresent(brand.uid),
        ブランド名: basicPresent(brand.name),
      };

      return pick(data, fields);
    });
  },
  existsRegistrationRequiredParams: (state) => {
    if (!state.editingBrand.uid) return false;
    if (!state.editingBrand.password) return false;
    if (!state.editingBrand.name) return false;
    if (!state.editingBrand.nameReading) return false;
    if (!state.editingBrand.postalCode) return false;
    if (!state.editingBrand.state) return false;
    if (!state.editingBrand.address) return false;
    if (!state.editingBrand.phone) return false;

    return true;
  },
  existsUpdateRequiredParams: (state) => {
    if (!state.editingBrand.name) return false;
    if (!state.editingBrand.nameReading) return false;
    if (!state.editingBrand.postalCode) return false;
    if (!state.editingBrand.state) return false;
    if (!state.editingBrand.address) return false;
    if (!state.editingBrand.phone) return false;

    return true;
  },
};
